<div
  class="relative"
  libClickOutSide
  insideSelector="[data-filter-panel], [data-date-range-panel]"
  (clickOutside)="onCancelFilters()">
  <button
    #filterButton
    type="button"
    (click)="toggleFilter()"
    data-filter-button
    class="relative flex items-center justify-center gap-sm font-medium text-sm transition-colors px-md"
    [class.rounded-3xl]="!isNewTableUi()"
    [class.py-x-sm]="!isNewTableUi()"
    [class.rounded-md]="isNewTableUi()"
    [class.border]="isNewTableUi()"
    [class.h-9]="isNewTableUi()"
    [class.bg-primary-50]="hasSelectedFilters()"
    [class.text-primary-700]="hasSelectedFilters()"
    [class.border-primary-200]="isNewTableUi() && hasSelectedFilters()"
    [class.bg-neutral-100]="!isNewTableUi() && !hasSelectedFilters()"
    [class.text-neutral-700]="!isNewTableUi() && !hasSelectedFilters()"
    [class.bg-white]="isNewTableUi() && !hasSelectedFilters()"
    [class.border-neutral-200]="isNewTableUi() && !hasSelectedFilters()"
    [class.text-neutral-900]="isNewTableUi() && !hasSelectedFilters()">
    @if (hasSelectedFilters()) {
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="absolute -top-0.5 -end-0.5 size-3">
        <circle cx="4" cy="4" r="3.5" fill="#EF4444" stroke="white" />
      </svg>
    }
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="size-3">
      <path
        d="M3.6 1.39844H12.4C13.1333 1.39844 13.7333 1.99844 13.7333 2.73177V4.19844C13.7333 4.73177 13.4 5.39844 13.0667 5.73177L10.2 8.2651C9.8 8.59844 9.53333 9.2651 9.53333 9.79844V12.6651C9.53333 13.0651 9.26666 13.5984 8.93333 13.7984L8 14.3984C7.13333 14.9318 5.93333 14.3318 5.93333 13.2651V9.73177C5.93333 9.2651 5.66666 8.6651 5.4 8.33177L2.86666 5.6651C2.53333 5.33177 2.26666 4.73177 2.26666 4.33177V2.79844C2.26666 1.99844 2.86666 1.39844 3.6 1.39844Z"
        [attr.stroke]="
          hasSelectedFilters() ? 'var(--color-primary-700)' : '#6B7280'
        "
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M7.28667 1.39844L4 6.6651"
        [attr.stroke]="
          hasSelectedFilters() ? 'var(--color-primary-700)' : '#6B7280'
        "
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

    @if (hasSelectedFilters()) {
      {{ selectedFiltersCount() }}
      {{ 'filter_dropdown_filters_active' | transloco }}
    } @else {
      {{ 'filter_dropdown_filters' | transloco }}
    }
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [class.rotate-180]="isFilterOpen()"
      class="transition-transform duration-200 size-3 mt-1">
      <path
        d="M11.31 0.75L6.96333 5.09667C6.45 5.61 5.61 5.61 5.09667 5.09667L0.75 0.75"
        [attr.stroke]="
          hasSelectedFilters() ? 'var(--color-primary-700)' : '#6B7280'
        "
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>

  @if (isFilterOpen()) {
    @if (isNewTableUi()) {
      <!-- Tables_new_design: the button sits at the toolbar's edge, so the panel is
           portalled with Tippy and kept inside the viewport (aligned to the button's end). -->
      <div
        data-filter-panel-anchor
        libTippyTooltip
        [contentTemplate]="filterPanel"
        placement="bottom-end"
        trigger="manual"
        [showOnInit]="true"
        interactive
        [referenceElement]="filterButton"
        [toolTipClass]="'bg-white rounded-md shadow-lg'"
        [offset]="[0, 8]"
        class="absolute inset-0 pointer-events-none"
        aria-hidden="true"></div>
    } @else {
      <div
        class="absolute top-full start-0 mt-sm bg-white rounded-md shadow-lg z-50">
        <ng-container [ngTemplateOutlet]="filterPanel" />
      </div>
    }
  }
</div>

<ng-template #filterPanel>
  <!-- Marked so this dropdown's click-outside counts clicks in the portalled panel as inside -->
  <div data-filter-panel>
    <form [formGroup]="filterForm" class="p-lg">
      <div class="mb-lg">
        <h6 class="text-neutral-900 font-semibold text-base">
          {{ 'filter_dropdown_filters_title' | transloco }}
        </h6>
      </div>
      @for (
        filterOption of processedFilterOptions();
        track filterOption.key;
        let i = $index
      ) {
        @if (filterOption.type !== 'resourceType') {
          <div class="flex items-center gap-lg mb-lg">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="flex-shrink-0 cursor-move size-5">
              <path
                d="M14.6166 7.33958C15.9789 7.33958 17.0832 6.23522 17.0832 4.87292C17.0832 3.51061 15.9789 2.40625 14.6166 2.40625C13.2543 2.40625 12.1499 3.51061 12.1499 4.87292C12.1499 6.23522 13.2543 7.33958 14.6166 7.33958Z"
                fill="#6B7280" />
              <path
                d="M5.38341 7.33958C6.74572 7.33958 7.85008 6.23522 7.85008 4.87292C7.85008 3.51061 6.74572 2.40625 5.38341 2.40625C4.02111 2.40625 2.91675 3.51061 2.91675 4.87292C2.91675 6.23522 4.02111 7.33958 5.38341 7.33958Z"
                fill="#6B7280" />
              <path
                d="M14.6166 17.5896C15.9789 17.5896 17.0832 16.4852 17.0832 15.1229C17.0832 13.7606 15.9789 12.6562 14.6166 12.6562C13.2543 12.6562 12.1499 13.7606 12.1499 15.1229C12.1499 16.4852 13.2543 17.5896 14.6166 17.5896Z"
                fill="#6B7280" />
              <path
                d="M5.38341 17.5896C6.74572 17.5896 7.85008 16.4852 7.85008 15.1229C7.85008 13.7606 6.74572 12.6562 5.38341 12.6562C4.02111 12.6562 2.91675 13.7606 2.91675 15.1229C2.91675 16.4852 4.02111 17.5896 5.38341 17.5896Z"
                fill="#6B7280" />
            </svg>
            <label
              class="text-base font-medium text-neutral-700 border border-neutral-300 rounded-md px-md py-sm h-[2.75rem] flex items-center w-[16.1875rem] flex-shrink-0">
              {{ filterOption.label }}
            </label>
            <div class="w-[18rem] flex-shrink-0">
              @if (filterOption.type === 'multi') {
                <lib-multi-select
                  [id]="filterOption.key + '-filter'"
                  [inputFormControlName]="filterOption.key"
                  [name]="filterOption.key"
                  [options]="filterOption.options || []"
                  [apiUrl]="filterOption.apiUrl || ''"
                  [filters]="filterOption.filters || []"
                  [preloadedResponse]="filterOption.preloadedResponse"
                  [selectedKeyName]="'label'"
                  [selectedKeyValue]="'value'"
                  [initialSelectedOptions]="filterOption.initialSelectedOptions"
                  [placeholder]="
                    filterOption.placeholder ||
                    ('filter_dropdown_select_placeholder' | transloco) +
                      ' ' +
                      filterOption.label
                  "
                  [title]="'filter_dropdown_filters_title' | transloco"
                  (changeOption)="
                    onMultiOptionChange(filterOption.key, $event)
                  " />
              } @else if (filterOption.type === 'dateRange') {
                <lib-date-range
                  [startDateControlName]="getStartDateKey(filterOption)"
                  [endDateControlName]="getEndDateKey(filterOption)"
                  [startDateLabel]="''"
                  [endDateLabel]="''"
                  [startDateId]="filterOption.key + '-start-date'"
                  [endDateId]="filterOption.key + '-end-date'"
                  [startDateName]="getStartDateKey(filterOption)"
                  [endDateName]="getEndDateKey(filterOption)"
                  (datesApplied)="
                    onDateRangeAppliedInComponent(filterOption.key)
                  " />
              } @else if (filterOption.type === 'paginated') {
                <lib-paginated-select
                  [id]="filterOption.key + '-filter'"
                  [inputFormControlName]="filterOption.key"
                  [name]="filterOption.key"
                  [apiUrl]="filterOption.apiUrl || ''"
                  [filters]="filterOption.paginatedFilters"
                  [selectedKeyName]="'label'"
                  [selectedKeyValue]="'value'"
                  [placeholder]="
                    filterOption.placeholder ||
                    ('filter_dropdown_select_placeholder' | transloco) +
                      ' ' +
                      filterOption.label
                  "
                  [detailsNotFoundLabel]="'details_not_found_label' | transloco"
                  [noDataLabel]="
                    'user_dropdown_input_no_data_label' | transloco
                  "
                  [selectedOption]="
                    getSelectedPaginatedOption(filterOption.key)
                  "
                  (changeOption)="
                    onPaginatedOptionChange(filterOption.key, $event)
                  "
                  [hasSearch]="filterOption.hasSearch ?? false" />
              } @else {
                <lib-select
                  [id]="filterOption.key + '-filter'"
                  [inputFormControlName]="filterOption.key"
                  [name]="filterOption.key"
                  [options]="filterOption.options || []"
                  selectedKeyName="label"
                  selectedKeyValue="value"
                  [placeholder]="
                    filterOption.placeholder ||
                    ('filter_dropdown_select_placeholder' | transloco) +
                      ' ' +
                      filterOption.label
                  "
                  [hasSearch]="false" />
              }
            </div>
            <button
              type="button"
              [id]="filterOption.key + '_reset_button'"
              (click)="resetFilter(filterOption.key)"
              [disabled]="!hasFilterValue(filterOption.key)"
              class="flex items-center gap-x-sm text-base font-medium flex-shrink-0 transition-colors"
              [class.text-neutral-500]="hasFilterValue(filterOption.key)"
              [class.cursor-pointer]="hasFilterValue(filterOption.key)"
              [class.text-neutral-300]="!hasFilterValue(filterOption.key)"
              [class.cursor-not-allowed]="!hasFilterValue(filterOption.key)">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="size-5">
                <path
                  d="M12.4082 4.23333C11.6832 4.01667 10.8832 3.875 9.9999 3.875C6.00824 3.875 2.7749 7.10833 2.7749 11.1C2.7749 15.1 6.00824 18.3333 9.9999 18.3333C13.9916 18.3333 17.2249 15.1 17.2249 11.1083C17.2249 9.625 16.7749 8.24167 16.0082 7.09167"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M13.4415 4.43073L11.0332 1.66406"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M13.4416 4.42969L10.6333 6.47969"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              {{ 'filter_dropdown_reset' | transloco }}
            </button>
          </div>
        } @else {
          <div class="mb-lg">
            <lib-resource-type
              [initialValue]="filterForm.get(filterOption.key)?.value || ''"
              (filterChange)="onResourceTypeChange(filterOption.key, $event)"
              (filterReset)="onResourceTypeReset(filterOption.key)" />
          </div>
        }
      }
    </form>

    <!-- Action Buttons -->
    <div class="flex items-center justify-between gap-md p-lg">
      <div>
        @if (appliedFiltersCount() > 1) {
          <button
            type="button"
            (click)="resetAllFilters()"
            class="text-base font-medium text-primary-600">
            {{ 'filter_dropdown_reset_all_filters' | transloco }}
          </button>
        }
      </div>
      <div class="flex items-center gap-md">
        <button
          type="button"
          (click)="onCancelFilters()"
          class="px-lg py-sm text-base font-medium text-neutral-700 bg-white border border-neutral-300 rounded-md hover:bg-neutral-50 transition-colors">
          {{ 'filter_dropdown_cancel' | transloco }}
        </button>
        <button
          type="button"
          (click)="onApplyFilters()"
          [disabled]="!hasFormFilters()"
          [class]="'px-lg py-sm text-base font-medium text-white bg-primary-500 rounded-md transition-colors'"
          [class.cursor-pointer]="hasFormFilters()"
          [class.cursor-not-allowed]="!hasFormFilters()"
          [class.opacity-60]="!hasFormFilters()">
          {{ 'filter_dropdown_apply' | transloco }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
